export function WhatBelievingHappyIs() {
  return (
    <section
      data-testid="believing-happy-definition-section"
      className="relative bg-[#FAFAF8]"
    >
      <div className="max-w-3xl mx-auto px-6 md:px-10 pt-[35px] md:pt-[44px] pb-[35px] md:pb-[44px] reveal">
        <p className="text-xs tracking-[0.24em] uppercase text-[#159E9A] mb-4">
          Believing Happy
        </p>
        <h2
          data-testid="believing-happy-definition-headline"
          className="font-display text-[30px] sm:text-[38px] lg:text-[44px] leading-[1.16] tracking-tight text-[#1C1917] max-w-2xl"
        >
          Happy isn&rsquo;t something you finally earn when everything is
          fixed.
        </h2>

        <div className="mt-6 space-y-4 text-lg md:text-xl leading-relaxed text-[#57534E] max-w-xl">
          <p>
            It isn&rsquo;t pretending hard things aren&rsquo;t hard.
            <br />
            It isn&rsquo;t being positive all the time.
            <br />
            And it definitely isn&rsquo;t waking up every morning thrilled
            about laundry and dental appointments.
          </p>
          <p className="text-[#1C1917]">Believing Happy is simpler than that.</p>
          <p>
            It&rsquo;s believing your life can feel more like yours.
            <br />
            That what delights you matters.
            <br />
            That curiosity is worth following.
            <br />
            That wanting something is information, not an indictment of
            everything you already have.
            <br />
            And that you don&rsquo;t need to blow up a perfectly good life to
            make more room for yourself inside it.
          </p>
        </div>

        <div className="mt-8 max-w-xl">
          <p className="text-lg md:text-xl leading-relaxed text-[#57534E]">
            Maybe happiness isn&rsquo;t something you find.
          </p>
          <p
            data-testid="believing-happy-definition-closing-line"
            className="mt-2 font-display italic text-2xl md:text-3xl leading-snug text-[#159E9A]"
          >
            Maybe it&rsquo;s something you start believing you&rsquo;re
            allowed to notice.
          </p>
        </div>
      </div>
    </section>
  );
}
